import $ from "jquery";
import AlertDialog from "../../../helper/alertDialog";
import validate from "../../../vendors/jquery.validate.min.js";

// 全域方法前後端使用
window.AlertDialog = AlertDialog;

$.validator.addMethod(
	"regx",
	function (value, element, regexpr) {
		return regexpr.test(value);
	},
	"請輸入正確手機格式"
);

$("#form-order-login").validate({
	errorClass: "text-danger error h6 pl-2 lh-15",
	errorElement: "div",
	rules: {
		email: {
			email: true,
			maxlength: 100,
			required: true,
		},
		transactionId: {
			required: true,
		},
		phone: {
			required: true,
			regx: /^[0-9]{5,15}$/,
		},
	},
	messages: {
		email: {
			email: "請輸入正確email格式",
			maxlength: "email過長，請重新輸入",
		},
		transactionId: {},
		phone: {},
	},
	errorPlacement: function (error, element) {
		element.parent().append(error);
	},
	submitHandler: function (form) {
		form.submit();
		return false;
	},
});
